module.exports = {
  data() {
    return {
      complianceServices: [],
    };
  },

  methods: {
    toggleRecords(type, service, itemIndex) {
      if (type === 'parent') {
        this.complianceServices[itemIndex][service].child.forEach((item, index) => {
          this.complianceServices[itemIndex][service].child[index].access = this.complianceServices[itemIndex][service][type];
        });
      } else {
        const result = this.complianceServices[itemIndex][service].child.every((item) => item.access === false);
        this.complianceServices[itemIndex][service].parent = !result;
      }
    },
    getServicesPermissions() {
      this.userServiceList.forEach((item, index) => {
        this.userServiceList[index].modules[0].access = this.complianceServices[index][item.key].parent;
        this.userServiceList[index].modules[index].operations = this.complianceServices[index][item.key].child;
      });
    },
  },
};
